import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - The Dragon's Table</title>
      </Helmet>
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <h1 className="mb-4" style={{ fontFamily: 'Cinzel, Georgia, serif', fontSize: '5rem', fontWeight: 700, color: 'var(--link)', letterSpacing: '0.05em' }}>404</h1>
        <h2 className="page-title mb-2">Page Not Found</h2>
        <p className="text-secondary mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary">
          Back to Home
        </Link>
      </div>
    </>
  );
};

export default NotFound;
